// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-input-area {
  padding: 0 24px 24px;
  background-color: var(--bg-primary);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-input-control {
  background-color: var(--bg-secondary);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: var(--shadow-lg);
  transition: all var(--transition-normal);
  position: relative;
}

.message-input-control:focus-within {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.05);
}

.message-input-control.has-reply {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.control-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
  outline: none;
}

.control-btn:hover {
  background-color: var(--bg-modifier-hover);
  color: var(--text-primary);
}

.control-btn.active {
  color: var(--brand-light) !important;
  background-color: var(--bg-modifier-selected) !important;
}

.upload-btn {
  color: var(--brand-light);
}

.message-input-field {
  flex: 1;
  min-width: 0;
  background: transparent;
  border: none;
  outline: none;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 10px 0;
}

.message-input-field::placeholder {
  color: var(--text-muted);
  opacity: 0.6;
}

.input-actions-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-divider {
  width: 1px;
  height: 24px;
  background-color: var(--glass-border);
  margin: 0 8px;
}

.send-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-modifier-hover);
  border: 1px solid var(--glass-border);
  color: var(--text-muted);
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: all var(--transition-normal);
}

.send-btn.active {
  background-color: var(--brand-primary);
  border-color: var(--brand-primary);
  color: white;
  box-shadow: 0 4px 12px rgba(153, 27, 27, 0.3);
}

.send-btn.active:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

/* Attachments */
.message-input-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 0 8px;
}

.attachment-card {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 1.5px solid var(--glass-border);
  background-color: var(--bg-tertiary);
  box-shadow: var(--shadow-md);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.attachment-card.uploading {
  opacity: 0.8;
  border-style: dashed;
}

.attachment-card.done {
  border-color: var(--brand-primary);
  border-style: solid;
}

.attachment-card.error {
  border-color: #ef4444;
}

.attachment-preview {
  width: 100%;
  height: 100%;
  position: relative;
}

.attachment-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.attachment-loader {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.attachment-error-overlay {
  position: absolute;
  inset: 0;
  background: rgba(239, 68, 68, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-remove-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  border: none;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.attachment-remove-btn:hover {
  background-color: var(--brand-primary);
  transform: scale(1.1);
}

/* Emoji Picker Popover Styles */
.input-emoji-picker-popover {
  position: absolute;
  bottom: 52px;
  right: 0;
  width: 260px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xl);
  padding: 12px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.emoji-picker-title {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--glass-border);
  padding-bottom: 6px;
  margin-bottom: 4px;
}

.emoji-picker-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  max-height: 180px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Custom Scrollbar for Emoji Grid */
.emoji-picker-grid::-webkit-scrollbar {
  width: 5px;
}

.emoji-picker-grid::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.emoji-picker-grid::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));
  border-radius: 4px;
}

.emoji-picker-grid::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

.emoji-picker-btn {
  background: transparent !important;
  border: none !important;
  font-size: 20px;
  padding: 4px;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  outline: none !important;
}

.emoji-picker-btn:hover {
  background-color: var(--bg-modifier-hover) !important;
  transform: scale(1.15);
}

/* Blocked state notice banner */
.blocked-input-area {
  padding-bottom: 24px;
}

.blocked-message-notice {
  background: rgba(30, 31, 34, 0.95);
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: var(--radius-lg);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.blocked-notice-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
}

.unblock-inline-btn {
  background: rgba(153, 27, 27, 0.2);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.4);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.unblock-inline-btn:hover {
  background: #dc2626;
  color: white;
  border-color: #dc2626;
  transform: scale(1.02);
}

/* Realtime Typing Indicator */
.typing-indicator-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
  padding: 0 8px;
  color: var(--text-muted, #94a3b8);
  font-size: 12px;
  font-weight: 500;
  user-select: none;
}

.typing-dots {
  display: inline-flex;
  gap: 3px;
  align-items: center;
}

.typing-dot {
  width: 5px;
  height: 5px;
  background-color: var(--brand-primary, #5865f2);
  border-radius: 50%;
  display: inline-block;
  animation: typingBounce 1.4s infinite ease-in-out both;
}

.typing-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-dot:nth-child(2) {
  animation-delay: -0.16s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes typingBounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.35;
  }
  40% {
    transform: scale(1.15);
    opacity: 1;
  }
}

.typing-text {
  letter-spacing: 0.2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


`, "",{"version":3,"sources":["webpack://./src/components/MessageInput/MessageInput.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,uCAAuC;EACvC,oCAAoC;EACpC,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".message-input-area {\n  padding: 0 24px 24px;\n  background-color: var(--bg-primary);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.message-input-control {\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: var(--shadow-lg);\n  transition: all var(--transition-normal);\n  position: relative;\n}\n\n.message-input-control:focus-within {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.05);\n}\n\n.message-input-control.has-reply {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.control-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n  outline: none;\n}\n\n.control-btn:hover {\n  background-color: var(--bg-modifier-hover);\n  color: var(--text-primary);\n}\n\n.control-btn.active {\n  color: var(--brand-light) !important;\n  background-color: var(--bg-modifier-selected) !important;\n}\n\n.upload-btn {\n  color: var(--brand-light);\n}\n\n.message-input-field {\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 10px 0;\n}\n\n.message-input-field::placeholder {\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n.input-actions-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.action-divider {\n  width: 1px;\n  height: 24px;\n  background-color: var(--glass-border);\n  margin: 0 8px;\n}\n\n.send-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-modifier-hover);\n  border: 1px solid var(--glass-border);\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: all var(--transition-normal);\n}\n\n.send-btn.active {\n  background-color: var(--brand-primary);\n  border-color: var(--brand-primary);\n  color: white;\n  box-shadow: 0 4px 12px rgba(153, 27, 27, 0.3);\n}\n\n.send-btn.active:hover {\n  transform: translateY(-2px);\n  filter: brightness(1.1);\n}\n\n/* Attachments */\n.message-input-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 0 8px;\n}\n\n.attachment-card {\n  width: 80px;\n  height: 80px;\n  position: relative;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  border: 1.5px solid var(--glass-border);\n  background-color: var(--bg-tertiary);\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.attachment-card.uploading {\n  opacity: 0.8;\n  border-style: dashed;\n}\n\n.attachment-card.done {\n  border-color: var(--brand-primary);\n  border-style: solid;\n}\n\n.attachment-card.error {\n  border-color: #ef4444;\n}\n\n.attachment-preview {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.attachment-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.attachment-loader {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loader-spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.attachment-error-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(239, 68, 68, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-remove-btn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 20px;\n  height: 20px;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.attachment-remove-btn:hover {\n  background-color: var(--brand-primary);\n  transform: scale(1.1);\n}\n\n/* Emoji Picker Popover Styles */\n.input-emoji-picker-popover {\n  position: absolute;\n  bottom: 52px;\n  right: 0;\n  width: 260px;\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-xl);\n  padding: 12px;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.emoji-picker-title {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--glass-border);\n  padding-bottom: 6px;\n  margin-bottom: 4px;\n}\n\n.emoji-picker-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 6px;\n  max-height: 180px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n/* Custom Scrollbar for Emoji Grid */\n.emoji-picker-grid::-webkit-scrollbar {\n  width: 5px;\n}\n\n.emoji-picker-grid::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.emoji-picker-grid::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));\n  border-radius: 4px;\n}\n\n.emoji-picker-grid::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n.emoji-picker-btn {\n  background: transparent !important;\n  border: none !important;\n  font-size: 20px;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.emoji-picker-btn:hover {\n  background-color: var(--bg-modifier-hover) !important;\n  transform: scale(1.15);\n}\n\n/* Blocked state notice banner */\n.blocked-input-area {\n  padding-bottom: 24px;\n}\n\n.blocked-message-notice {\n  background: rgba(30, 31, 34, 0.95);\n  border: 1px solid rgba(239, 68, 68, 0.25);\n  border-radius: var(--radius-lg);\n  padding: 14px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n.blocked-notice-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: #94a3b8;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.unblock-inline-btn {\n  background: rgba(153, 27, 27, 0.2);\n  color: #f87171;\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.unblock-inline-btn:hover {\n  background: #dc2626;\n  color: white;\n  border-color: #dc2626;\n  transform: scale(1.02);\n}\n\n/* Realtime Typing Indicator */\n.typing-indicator-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 20px;\n  padding: 0 8px;\n  color: var(--text-muted, #94a3b8);\n  font-size: 12px;\n  font-weight: 500;\n  user-select: none;\n}\n\n.typing-dots {\n  display: inline-flex;\n  gap: 3px;\n  align-items: center;\n}\n\n.typing-dot {\n  width: 5px;\n  height: 5px;\n  background-color: var(--brand-primary, #5865f2);\n  border-radius: 50%;\n  display: inline-block;\n  animation: typingBounce 1.4s infinite ease-in-out both;\n}\n\n.typing-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n.typing-dot:nth-child(3) {\n  animation-delay: 0s;\n}\n\n@keyframes typingBounce {\n  0%, 80%, 100% {\n    transform: scale(0.6);\n    opacity: 0.35;\n  }\n  40% {\n    transform: scale(1.15);\n    opacity: 1;\n  }\n}\n\n.typing-text {\n  letter-spacing: 0.2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
